export enum MFA_LOYALTY_GROUPS {
  LOYALTY = 'loyalty',
  LOYALTY_MFA_EMAIL = 'loyalty-mfa-email',
  LOYALTY_MFA_SMS = 'loyalty-mfa-sms',
  LOYALTY_MFA_EMAIL_SMS = 'loyalty-mfa-email-sms',
}
